<template>
  <div>
    <search-supplier-cpe @submit="submitSearch" />

    <a-table
      size="middle"
      :columns="columns"
      :data-source="data"
      :loading="loading"
      :scroll="{ x: 'max-content' }"
      :pagination="false"
      row-key="id"
    />

    <pagination
      v-show="pagination.total_count > 0"
      :total-count="pagination.total_count"
      :page.sync="query.page"
      :per-page.sync="query.per_page"
      @change="fetchData"
    />
  </div>
</template>

<script>
import { findCpeSupplierCpes } from '@/api/cpe_supplier'
import Pagination from '@/components/Pagination'
import SearchSupplierCpe from '@/views/cpes/supplier/Search'

export default {
  name: 'SupplierCpeList',
  components: {
    Pagination,
    SearchSupplierCpe
  },
  data() {
    return {
      data: [],
      loading: true,
      pagination: {
        total_count: 0
      },
      query: {},
      columns: [
        {
          title: '采购型号',
          dataIndex: 'cpe_model_name',
          width: 140
        },
        {
          title: '对外展示型号',
          dataIndex: 'display_model',
          width: 140
        },
        {
          title: '通讯方式',
          dataIndex: 'comm_mode_name',
          width: 140
        },
        {
          title: 'SN',
          dataIndex: 'sn',
          width: 160
        },
        {
          title: 'IMEI1',
          dataIndex: 'imei1',
          width: 160
        },
        {
          title: 'IMEI2',
          dataIndex: 'imei2',
          width: 160
        },
        {
          title: '划拨时间',
          dataIndex: 'allocated_at',
          width: 170
        },
        {
          title: '所属客户',
          dataIndex: 'agent_name',
          width: 160
        }
      ]
    }
  },
  computed: {
    cpeSupplierId() {
      return parseInt(this.$route.params.id)
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    submitSearch(search) {
      this.query = Object.assign({},
        this.$options.data().query,
        { per_page: this.query.per_page },
        search
      )
      this.fetchData()
    },

    fetchData() {
      this.loading = true
      findCpeSupplierCpes(this.cpeSupplierId, this.query).then((res) => {
        if (res.code === 0) {
          this.data = res.data
          this.pagination = res.pagination
        }
        this.loading = false
      })
    }
  }
}
</script>
